module.exports = __webpack_public_path__ + "img/dashboard.41361a8d.svg";